import React, { useState } from 'react';
import { Icon, Popconfirm } from 'antd';
import * as S from './styles';
import { withTranslation } from 'react-i18next';
import { JOB_DETAILS_UI } from '../TranslationValues';

const NAMESPACES = ['JOB_DETAILS_UI', 'STATUS_MONITORING'];
const ADVANCED_BATCH_TOTAL_STEPS = 5;

const DraftStatus = ({ batch, onContinueEdit, isHybridDraft, handleCancel, t }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isDiscard, setIsDiscard] = useState(false);
   const handleVisibleChange = (visible) => {
    setIsDiscard(visible);
  };
  return (
    <>
      {/* Draft Info Card */}
      <S.DraftCard>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
          <S.IconCircle bgColor="#9c179e">
            <Icon type="info-circle" style={{ fontSize: '24px', color: 'white' }} />
          </S.IconCircle>
          <S.CardContent>
            <S.CardTitle>
              {t(JOB_DETAILS_UI.DRAFT_HEADER.key, JOB_DETAILS_UI.DRAFT_HEADER.value)}
            </S.CardTitle>
            <S.CardText>
              {isHybridDraft
                ? t(
                    JOB_DETAILS_UI.HYBRID_BATCH_DRAFT_DESCRIPTION.key,
                    JOB_DETAILS_UI.HYBRID_BATCH_DRAFT_DESCRIPTION.value,
                  )
                : t(JOB_DETAILS_UI.DRAFT_DESCRIPTION.key, JOB_DETAILS_UI.DRAFT_DESCRIPTION.value, {
                    currentStep: batch?.stageNumber,
                    totalSteps: ADVANCED_BATCH_TOTAL_STEPS,
                  })}
            </S.CardText>
            <S.ButtonGroup>
              <S.PrimaryButton
                onClick={() => {
                  batch?.batchType === 'ADVANCED' && setIsLoading(true);
                  onContinueEdit(() => setIsLoading(false));
                }}
                disabled={isLoading || isDeleting}
              >
                {isLoading ? <Icon type="loading" /> : <Icon type="edit" />}
                {isHybridDraft
                  ? t(
                      JOB_DETAILS_UI.CONTINUE_PROCESSING.key,
                      JOB_DETAILS_UI.CONTINUE_PROCESSING.value,
                    )
                  : t(JOB_DETAILS_UI.CONTINUE_EDITING.key, JOB_DETAILS_UI.CONTINUE_EDITING.value)}
              </S.PrimaryButton>
              <Popconfirm
                title={t(
                  JOB_DETAILS_UI.DISCARD_CONFIRMATION.key,
                  JOB_DETAILS_UI.DISCARD_CONFIRMATION.value,
                )}
                okText={'Yes'}
                cancelText={'Cancel'}
                placement="top"
                trigger="click"
                visible={isDiscard}
                onConfirm={() => {
                  setIsDeleting(true);
                  setIsDiscard(false);
                  handleCancel(() => setIsDeleting(false));
                }}
                onVisibleChange={handleVisibleChange}
                onCancel={() => setIsDiscard(false)}
              >
                <S.SecondaryButton
                  disabled={isLoading || isDeleting}
                  onClick={() => setIsDiscard(!isDiscard)}
                >
                  {isDeleting ? <Icon type="loading" /> : <Icon type="close-circle" />}
                  {t(JOB_DETAILS_UI.DISCARD_DRAFT.key, JOB_DETAILS_UI.DISCARD_DRAFT.value)}
                </S.SecondaryButton>
              </Popconfirm>
            </S.ButtonGroup>
          </S.CardContent>
        </div>
      </S.DraftCard>

      {/* Progress Indicator */}
      {!isHybridDraft && (
        <S.ContentCard>
          <S.CardHeader>
            {t(JOB_DETAILS_UI.SETUP_PROGRESS.key, JOB_DETAILS_UI.SETUP_PROGRESS.value)}
          </S.CardHeader>
          <S.ProgressContainer>
            <S.ProgressInfo>
              <S.ProgressText>
                {t(JOB_DETAILS_UI.STEP_PROGRESS.key, JOB_DETAILS_UI.STEP_PROGRESS.value, {
                  currentStep: batch?.stageNumber,
                  totalSteps: ADVANCED_BATCH_TOTAL_STEPS,
                })}
              </S.ProgressText>
              <S.ProgressPercent>
                {Math.round((batch?.stageNumber / ADVANCED_BATCH_TOTAL_STEPS) * 100)}%
              </S.ProgressPercent>
            </S.ProgressInfo>
            <S.ProgressBarWrapper>
              <S.ProgressBar
                width={`${(batch?.stageNumber / ADVANCED_BATCH_TOTAL_STEPS) * 100}%`}
              />
            </S.ProgressBarWrapper>
          </S.ProgressContainer>
        </S.ContentCard>
      )}
    </>
  );
};

export default withTranslation(NAMESPACES)(DraftStatus);
